import { Producto } from "./Producto";

export class Aerocombustible extends Producto
{
  densidadMin: number;
  densidadMax: number;
}
